// @ts-expect-error: no types for ui-addon-iframeable
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
export const MARKETING_STUDIO_APP = 'marketing-studio';
export const MESSAGE_TYPES = {
  APP_STARTING: 'appStarting',
  UNLOAD: 'unload',
  NAVIGATE: 'navigate',
  ERROR: 'error',
  ON_PUBLISH: 'onPublish',
  CLOSE_EDITOR: MSG_TYPE_MODAL_DIALOG_CLOSE
};
export const ANCHOR_NAVIGATION_QUERY_PARAM = 'navigateToAnchorFromStudio';
export const TEST_EMBEDDED_VERSION_OUTSIDE_IFRAME = 'testEmbeddedVersionOutsideIframe';
export const EMBEDDED_IN_APP_NAME_DATA_ATTRIBUTE = 'embeddedInAppName';
export const EMBEDDED_FRAME_ID_QUERY_PARAM = 'embeddedFrameId';